import { render, staticRenderFns } from "./AlertSettingsForm.vue?vue&type=template&id=fff1699e&scoped=true"
import script from "./AlertSettingsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertSettingsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertSettingsForm.vue?vue&type=style&index=0&id=fff1699e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff1699e",
  null
  
)

export default component.exports